import { stepGuide } from '@/mocks/movies';

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="w-full lg:w-[38%]">
            <span className="inline-flex items-center gap-2 text-primary-700 text-xs md:text-sm font-medium tracking-wide">
              <i className="ri-route-line" />
              观看指南
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 text-balance">
              从打开入口到看完内容的五步
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              第一次访问时，按下面的顺序走一遍就能熟悉整个页面。每一步都很短，实际操作下来只需要几分钟。
            </p>

            <div className="mt-6 rounded-lg bg-primary-50 border border-primary-200/70 p-5">
              <div className="flex items-center gap-2 text-primary-700">
                <i className="ri-information-line text-lg" />
                <span className="text-sm font-medium">小提示</span>
              </div>
              <p className="mt-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                如果你只想快速开始，直接跳到「精选片单」用类型标签筛选，找出想看的条目再返回本区对照设置即可。
              </p>
            </div>
          </div>

          <div className="w-full lg:w-[62%]">
            <ol className="relative border-l border-background-300/70 ml-3 md:ml-5">
              {stepGuide.map((s, idx) => (
                <li key={s.n} className={`relative pl-7 md:pl-9 ${idx === stepGuide.length - 1 ? '' : 'pb-8'}`}>
                  <span className="absolute -left-[13px] top-0 w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-[11px] md:text-xs font-semibold">
                    {s.n}
                  </span>
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed">
                    {s.desc}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}